import { Modal, Tab } from "react-bootstrap"
import { imsLoader } from "../../../assets";
import { useEffect, useState } from "react";
import { act } from "react";
import AlertMessagePopUpModal from "../../PopUp/AlertMessagePopUpModal";
export const NoteBookConfigurePopUp = (props) => {

    const [spinnerMessage, setSpinnerMessage] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [responseLength, setResponseLength] = useState('Default');
    const [converCustom, setConverCustom] = useState('');
    const [alertMessageShowModal, setalertMessageShowModal] = useState(false);
    const [alertMessageContent, setalertMessageContent] = useState("")
    const [alertMessageModelColor, setalertMessageModelColor] = useState("")


    const custon_text_static = 'Examples:​ \n  Respond like a scientific writer explaining to an HCP​\n  Respond like an HCP explaining to a patient​\n  Suggest different roles “You are a trainer for Medical Scientific Liaisons helping to provide suggestions for clear responses to HCPs”  ​\n  Suggest different roles “ You are an MSL who has received a reactive request from an HCP to briefly review clinical data. “Summarize the key findings, clinical relevance, and any safety or efficacy highlights from the uploaded poster. Provide a bullet-point summary suitable for an HCP discussion.” ​'


    const conversational_learning_guide = 'Generate summary in points. \n Respond like a scientific writer explaining to an HCP'

    useEffect(() => {
        if (props.configActiveTab) {
            setActiveTab(props.configActiveTab)
        }
        if (props.configResponseLength) {
            setResponseLength(props.configResponseLength)
        }
        if (props.configConversationa) {
            setConverCustom(props.configConversationa)
        }
    }, [])


    const handleSave = () => {
        let conver = '';
        if (activeTab === 0) {
            conver = ''
        } else if (activeTab === 1) {
            conver = conversational_learning_guide
        } else if (activeTab === 2) {
            conver = converCustom
        }
        if (activeTab === 2 && converCustom.trim().length < 1) {
            errorAlertMessage('Custom Conversational goal text box cannot be empty.')
        } else {
            props.handleConfigSave(activeTab, conver, responseLength)
        }
    }
    const successAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#00c12c")
        setalertMessageShowModal(true)
    }
    const errorAlertMessage = (message) => {
        setalertMessageContent(message)
        setalertMessageModelColor("#EB1007")
        setalertMessageShowModal(true)
    }
    const closeAlertMessage = () => {
        setalertMessageContent("")
        setalertMessageModelColor("")
        setalertMessageShowModal(false)
    }
    const handleClose = () =>{
        setActiveTab(0);
        setResponseLength('Default');
        setConverCustom('')
    }
    return (<Modal
        show={props.showModal}
        size="lg md sm xs"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName="create-modal-popup"
        scrollable={true}
    >
        <div className="create-note-book-popup" style={{ /*overflow: "auto",*/ maxHeight: '91vh' }}>
            <Modal.Header
                className="gsfModalHeader"
                style={{ justifyContent: "left", background: '#FFFF', width: '100%' }}
            >
                <div
                    style={{
                        textAlign: "center",
                        width: "100%",
                        paddingTop: "1%",
                    }}
                >
                    <Modal.Title>
                        <div className="Note-Book-header">
                            <div>Configure Chat​</div>
                            <div className="Note-Book-header-close"
                                onClick={(e) => {
                                    handleClose()
                                    props.handleClose(false);
                                }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </Modal.Title>
                </div>
            </Modal.Header>
            {<Modal.Body scrollable={true} className="create-notebook-genai-body config-txt">
                <div className="notebook-genai-source-con gap-15">
                    <p>Notebooks can be customized to help you achieve different goals: do research, create a learning module, show perspectives, develop a writing assistant.</p>
                    <span>Define your conversational goal, style, or role​</span>
                    <div className="configure-btn-group">
                        <div className={(activeTab === 0) ? "configure-btn congfig-btn-actv" : "configure-btn"} onClick={() => {setActiveTab(0); setConverCustom('')}}>
                            {(activeTab === 0) && <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#FFFFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 7L9.42857 17L6 13" stroke="#FFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                            </svg>}<span>Default</span></div>
                        <div className={(activeTab === 1) ? "configure-btn congfig-btn-actv" : "configure-btn"} onClick={() => {setActiveTab(1); setConverCustom(conversational_learning_guide)}}>
                            {(activeTab === 1) && <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#FFFFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 7L9.42857 17L6 13" stroke="#FFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                            </svg>}<span>Learning Guide</span></div>
                        <div className={(activeTab === 2) ? "configure-btn congfig-btn-actv" : "configure-btn"} onClick={() => {setActiveTab(2); setConverCustom('')}}>
                            {(activeTab === 2) && <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#FFFFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 7L9.42857 17L6 13" stroke="#FFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                            </svg>}<span>Custom</span></div>
                    </div>
                    <textarea className="notebook-genai-browser mx-8 config-txt" placeholder={(activeTab === 2) ? custon_text_static : ''} disabled={activeTab === 0} value={converCustom} onChange={(e) => { setConverCustom(e.target.value) }} />
                </div>
                <div className="notebook-genai-source-con gap-15">
                    <span>Choose your response length​</span>
                    <div className="configure-btn-group">
                        <div className={(responseLength === 'Default') ? "configure-btn congfig-btn-actv" : "configure-btn"} onClick={() => setResponseLength('Default')}>
                            {(responseLength === 'Default') && <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#FFFFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 7L9.42857 17L6 13" stroke="#FFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                            </svg>}
                            <span>Default</span>
                        </div>
                        <div className={(responseLength === 'Shorter') ? "configure-btn congfig-btn-actv" : "configure-btn"} onClick={() => setResponseLength('Shorter')}>
                            {(responseLength === 'Shorter') && <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#FFFFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 7L9.42857 17L6 13" stroke="#FFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                            </svg>}<span>Shorter</span></div>
                        <div className={(responseLength === 'Longer') ? "configure-btn congfig-btn-actv" : "configure-btn"} onClick={() => setResponseLength('Longer')}>
                            {(responseLength === 'Longer') && <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#FFFFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 7L9.42857 17L6 13" stroke="#FFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                            </svg>}<span>Longer</span></div>
                    </div>
                </div>
                <div className="notebook-genai-source-con">
                    <div className="notebook-genai-config-popup">
                        <div className={"notebook-genai-cc config-save-btn"} onClick={handleSave}>Save</div>
                    </div>
                </div>
            </Modal.Body>}
            {isProcessing &&
                <Modal
                    show={isProcessing}
                    size="lg md sm xs"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="savePopUp"
                    className="gen-ai-answering-search-spinner-popup"
                    backdropClassName="z-index-gen-ai-answering-search-spinner-popup"
                    scrollable={true}>
                    <div style={{ padding: "0 5%" }}>
                        <div style={{ fontSize: "14px", textAlign: "center" }}>
                            <Modal.Body>
                                <img src={imsLoader} alt="" width={100} height={100} />
                                <div className="saveModal-heading" style={{ color: "#EB1700" }}>{spinnerMessage ? spinnerMessage : `Please wait while finding answers.`} </div>
                            </Modal.Body>
                        </div>
                    </div>
                </Modal>}
            {alertMessageShowModal && <AlertMessagePopUpModal
                color={alertMessageModelColor}
                content={alertMessageContent}
                showModal={alertMessageShowModal}
                handleClose={() => closeAlertMessage()} />}
        </div>
    </Modal>
    )
}